import React from 'react';
import { MessageSquare } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { isMobileContainer } from '../../utils/device';

export default function FloatingFeedbackButton({ onClick }) {
  const isMobile = isMobileContainer();

  const buttonInner = (
    <button
      type="button"
      onClick={onClick}
      aria-label="Send Feedback"
      data-testid="floating-feedback-button"
      className={`group fixed z-50 right-4 md:right-6 bottom-[calc(var(--mobile-nav-offset,0px)+1rem)] md:bottom-6 flex items-center ${
        isMobile ? 'active:scale-95' : ''
      }`}
    >
      <span
        className="absolute inset-0 rounded-full bg-blue-500/40 animate-ping opacity-75"
        style={{ animationDuration: '3s' }}
        aria-hidden
      />
      <span
        className={`relative flex items-center justify-center bg-blue-600 text-white shadow-lg shadow-blue-600/30 transition-all duration-300 hover:scale-105 hover:bg-blue-700 hover:shadow-xl ${
          isMobile
            ? 'h-12 px-4 rounded-full gap-2'
            : 'h-14 w-14 rounded-full group-hover:w-auto group-hover:px-4 group-hover:rounded-full'
        }`}
      >
        <MessageSquare className={`h-6 w-6 shrink-0 ${isMobile ? '' : 'group-hover:mr-2'} transition-all`} />
        {isMobile ? (
          <span className="text-sm font-semibold whitespace-nowrap">Feedback</span>
        ) : (
          <span className="hidden group-hover:inline text-sm font-semibold whitespace-nowrap pr-1">
            Feedback
          </span>
        )}
      </span>
    </button>
  );

  if (isMobile) {
    return buttonInner;
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{buttonInner}</TooltipTrigger>
        <TooltipContent side="left">Send Feedback</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
